import { startsWith } from 'es-toolkit/compat';

import { consumer, safeEnumCompare } from '@tock/coretypes';
import { parseUrl } from 'utils/domainUtils';
import { urlWithQuery } from './domainUtils';
import consumerProtos from 'utils/consumerProto';
import protos from 'utils/protos';

const { DomainConfig } = consumerProtos;

if (!protos.TicketType.Variety) {
  throw new Error('Could not resolve ticket type');
}

/**
 * returns true if a redirect occured, false otherwise
 */
export function redirectIfNecessary(
  url: string,
  context: consumer.DomainConfig.Context | null | undefined,
  redirectCallback: (path: string) => void
) {
  const isProfileDomain = startsWith(url, '/profile');
  const isPartnerDomain = startsWith(url, '/concierge');
  const isWwwDomain = safeEnumCompare(context, DomainConfig.Context, DomainConfig.Context.WWW);

  if (isWwwDomain || isPartnerDomain || isProfileDomain) {
    return false;
  }

  // Specially handle deep links.
  if (startsWith(url, '/checkout/size')) {
    const parsedUrl = parseUrl(url);
    const query = parsedUrl.query;
    const experienceId = query.experienceId;
    delete query.experienceId;
    redirectCallback(urlWithQuery(`/experience/${experienceId}/`, query));
    return true;
  }

  if (startsWith(url, '/experience')) {
    const parsedUrl = parseUrl(url);
    const query = parsedUrl.query;
    const experienceId = query.experienceId;
    if (experienceId) {
      delete query.experienceId;
      redirectCallback(urlWithQuery(`/experience/${experienceId}/`, query));
      return true;
    }
    return false;
  }

  return false;
}
